<template>
  <div class="layout_footer">© 2023 - {{appTitle}} V1.0</div>
</template>

<script setup>
import { onMounted, ref, onUnmounted } from "vue";
import { ElMessage } from "element-plus";
import { useRouter, useRoute } from "vue-router";
import { useStore } from "vuex";
import { setStorage, getStorage, removeStorage } from '@/utils'  

const store = useStore();
let router = useRouter(); //路由
const route = useRoute();
const appTitle  = ref(getStorage("APP_TITLE")) //管理系统标题

</script>
<style lang="scss" scoped>
.layout_footer {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909090;
  font-size: 14px;
  letter-spacing: 3px;
}
</style>
